import { render, staticRenderFns } from "./ProductSlot.vue?vue&type=template&id=1904c228&scoped=true&"
import script from "./ProductSlot.vue?vue&type=script&lang=js&"
export * from "./ProductSlot.vue?vue&type=script&lang=js&"
import style0 from "./ProductSlot.vue?vue&type=style&index=0&id=1904c228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1904c228",
  null
  
)

export default component.exports